module.exports = __webpack_public_path__ + "img/4-2.110d1b30.svg";